var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.numPages),function(item,index){return _c('span',{key:index},[_c('pdf',{ref:"pdf",refInFor:true,attrs:{"src":_vm.src,"page":index + 1}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }